import ActionQueue from "./action-queue";
import ActionFactory from "./action-factory";
import { ActionTypeEnum } from "./training-literals";

export default class EventLoop {
    training;
    runningActions;
    time;
    actionQueue;

    constructor(training) {
        this.training = training;
        this.runningActions = [];
        this.time = 0;
        this.actionQueue = new ActionQueue();
    }

    async tick(deltaTime) {
        this.time += deltaTime;

        const actions = this.actionQueue.nextAction(this.time);
        for (let action of actions) {
            await this.executeAction(action);
        }

        return this.actionQueue.isEmpty();
    }

    async executeAction(action) {
        this.runningActions.push(action);
        await action.execute(this);
    }

    getModelNameFromID(modelId){
        return this.training.resources[modelId].name;
    }

    addTimelines(timelineIdList) {
        const self = this;
        timelineIdList.forEach(startTimeline);

        function startTimeline(id) {
            const timeline = self.training.timelines[id];
            externalSignalReceiverManager.stopAllExternalSignalReceiverActions();
            if (timeline) self.actionQueue.add(timeline, self.time, timeline.actionSequence);
        }
    }

    addActionsToQueue(timeline, actionPropsArray) {
        if (!actionPropsArray || actionPropsArray.length === 0) return;
        const actions = actionPropsArray.map(props => ActionFactory.create(props));
        this.actionQueue.add(timeline, this.time, actions);
    }

    async stop(retainState = false) {
        if (!retainState) {
            await this.pruneActions(this.runningActions);
        } else {
            const mustStopActionTypes = new Set([ActionTypeEnum.PLAY_AUDIO]);
            await this.pruneActions(
                this.runningActions.filter(action => mustStopActionTypes.has(action.type))
            );
        }
    }

    pruneTimelinesByClass(classList) {
        for (let className of classList)
            this.actionQueue.prune(className);
        this.actionQueue.pruneDeleted();
    }

    async pruneActionsByClass(classList) {
        const prunedActions = this.runningActions.filter(action => onPruneList(classList, action));
        this.runningActions = this.runningActions.filter(action => !onPruneList(classList, action));

        // restore the previous class name if it was changed
        prunedActions.forEach(action => {
            if (action.previousClassName) {
                action.className = action.previousClassName;
                delete action.previousClassName;
            }
        });

        return this.pruneActions(prunedActions);

        function onPruneList(items, action) {
            const matchesCurrent = !!items.find(item => item === action.className);
            const matchesPrevious = action.previousClassName && !!items.find(item => item === action.previousClassName);
            return action.type === ActionTypeEnum.STEP_INSTRUCTION_MENU ? matchesCurrent : matchesCurrent || matchesPrevious;
        }
    }

    getActionsByClassName(className) {
        return this.runningActions.filter(action => action.className === className);
    }

    async pruneActions(actions) {
        const stopPromises = actions.map(async action => await action.stop(this.training, this.runningActions));
        return Promise.all(stopPromises);
    }
}
